/** Minimal PDF writer — zero dependencies (Phase 10). */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function encoder() {
    return new TextEncoder();
}
function mergeChunks(chunks) {
    var e_1, _a;
    var total = chunks.reduce(function (s, c) { return s + c.length; }, 0);
    var out = new Uint8Array(total);
    var o = 0;
    try {
        for (var chunks_1 = __values(chunks), chunks_1_1 = chunks_1.next(); !chunks_1_1.done; chunks_1_1 = chunks_1.next()) {
            var c = chunks_1_1.value;
            out.set(c, o);
            o += c.length;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (chunks_1_1 && !chunks_1_1.done && (_a = chunks_1.return)) _a.call(chunks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return out;
}
/** Build a multi-page PDF embedding JPEG images. */
export function buildPdfFromJpegPages(pages) {
    var _a;
    if (pages.length === 0) {
        return encoder().encode('%PDF-1.4\n1 0 obj<<>>endobj\ntrailer<<>>\n%%EOF\n');
    }
    var enc = encoder();
    var parts = [];
    var pos = 0;
    var offsets = [0];
    var append = function (text) {
        var b = enc.encode(text);
        parts.push(b);
        pos += b.length;
    };
    var appendBytes = function (bytes) {
        parts.push(bytes);
        pos += bytes.length;
    };
    var startObj = function (id, header) {
        while (offsets.length <= id)
            offsets.push(0);
        offsets[id] = pos;
        append("".concat(id, " 0 obj\n").concat(header));
    };
    append('%PDF-1.4\n');
    var n = pages.length;
    var imgIds = [];
    var contentIds = [];
    var pageIds = [];
    var id = 1;
    for (var i = 0; i < n; i++) {
        imgIds.push(id++);
        contentIds.push(id++);
        pageIds.push(id++);
    }
    var pagesTreeId = id++;
    var catalogId = id++;
    for (var i = 0; i < n; i++) {
        var page = pages[i];
        var imgId = imgIds[i];
        startObj(imgId, "<< /Type /XObject /Subtype /Image /Width ".concat(page.width, " /Height ").concat(page.height, " ") +
            "/ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ".concat(page.jpeg.length, " >>\nstream\n"));
        appendBytes(page.jpeg);
        append('\nendstream\nendobj\n');
        var imgName = "Im".concat(imgId);
        var ops = "q ".concat(page.width, " 0 0 ").concat(page.height, " 0 0 cm /").concat(imgName, " Do Q");
        var opsBytes = enc.encode(ops);
        var contentId = contentIds[i];
        startObj(contentId, "<< /Length ".concat(opsBytes.length, " >>\nstream\n"));
        appendBytes(opsBytes);
        append('\nendstream\nendobj\n');
        var pageId = pageIds[i];
        startObj(pageId, "<< /Type /Page /Parent ".concat(pagesTreeId, " 0 R /MediaBox [0 0 ").concat(page.width, " ").concat(page.height, "] ") +
            "/Contents ".concat(contentId, " 0 R /Resources << /XObject << /").concat(imgName, " ").concat(imgId, " 0 R >> >> >>\nendobj\n"));
    }
    var kids = pageIds.map(function (p) { return "".concat(p, " 0 R"); }).join(' ');
    startObj(pagesTreeId, "<< /Type /Pages /Kids [".concat(kids, "] /Count ").concat(n, " >>\nendobj\n"));
    startObj(catalogId, "<< /Type /Catalog /Pages ".concat(pagesTreeId, " 0 R >>\nendobj\n"));
    var xrefPos = pos;
    append("xref\n0 ".concat(catalogId + 1, "\n"));
    append('0000000000 65535 f \n');
    for (var i = 1; i <= catalogId; i++) {
        append("".concat(String((_a = offsets[i]) !== null && _a !== void 0 ? _a : 0).padStart(10, '0'), " 00000 n \n"));
    }
    append("trailer\n<< /Size ".concat(catalogId + 1, " /Root ").concat(catalogId, " 0 R >>\n"));
    append("startxref\n".concat(xrefPos, "\n%%EOF\n"));
    return mergeChunks(parts);
}
/** Encode PDF bytes as base64 data URI. */
export function pdfToDataUrl(pdf) {
    var binary = '';
    for (var i = 0; i < pdf.length; i++) {
        binary += String.fromCharCode(pdf[i]);
    }
    return "data:application/pdf;base64,".concat(btoa(binary));
}
/** Decode base64 data URL to bytes. */
export function dataUrlToBytes(dataUrl) {
    var comma = dataUrl.indexOf(',');
    var base64 = comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl;
    var binary = atob(base64);
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i++)
        bytes[i] = binary.charCodeAt(i);
    return bytes;
}
/** Minimal JPEG stub with valid SOI/EOI markers for PDF structure tests. */
export function createMinimalJpegStub(width, height) {
    var header = encoder().encode("\u00FF\u00D8\u00FF\u00E0\0\u0010JFIF\0\u0001\u0001\0\0\u0001\0\u0001\0\0");
    var comment = encoder().encode("LIGHTDRAW ".concat(width, "x").concat(height));
    var eoi = new Uint8Array([0xff, 0xd9]);
    var out = new Uint8Array(header.length + comment.length + eoi.length);
    out.set(header, 0);
    out.set(comment, header.length);
    out.set(eoi, header.length + comment.length);
    return out;
}
